/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Atelier_Point_4Inputs */

const en_atelier_point_4 = /** @type {(inputs: Atelier_Point_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Two-factor sign-in and passkeys`)
};

/**
* | output |
* | --- |
* | "Two-factor sign-in and passkeys" |
*
* @param {Atelier_Point_4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const atelier_point_4 = /** @type {((inputs?: Atelier_Point_4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Atelier_Point_4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_atelier_point_4(inputs)
});